import { formatInTimeZone } from 'date-fns-tz'

export const ADMIN_DEFAULT_TIME_ZONE = 'Asia/Singapore'

export const formatDate = (
  date: string | number | Date,
  format: string = 'dd MMM yyyy, HH:mm',
  timeZone: string = ADMIN_DEFAULT_TIME_ZONE
) => formatInTimeZone(date, timeZone, format)
